export default "__VITE_ASSET__N0vdC4We__"